<template>
	<div class="chatbot">
		<p>Instruktion</p>
		<div id="konversation">
			<div id="nachrichten" ref="nachrichten">
				<div v-for="(nachricht, nachrichtx) in nachrichten" v-bind:key="nachrichtx" class="nachricht" v-bind:id="nachricht.id"  v-bind:ref="nachricht.id">
					<v-avatar class="atavar" v-bind:class="{ 'atavarbot' : nachricht.sender == 'AVENUEbot'}" color="primary" size="3em">
						<img v-if="nachricht.sender == 'AVENUEbot'" src="../assets/chatbot.jpg" alt="Chatbot" />
						<v-icon v-else dark>mdi-account-circle </v-icon>
					</v-avatar>
					<p class="sprechblase" v-bind:class="{ 'sprechblasebot' : nachricht.sender == 'AVENUEbot'}">{{nachricht.message}}</p>
				</div>
			</div>
			<div id="eingabe">
				<v-text-field v-model="nachrichtEingabe" label="Nachricht senden" @keydown.enter="nachrichtSenden"></v-text-field>
			</div>
		</div>
	</div>
</template>
<script>
	import axios from 'axios';
	export default {
		name: 'chatbot',
		data() {
			return {
				nachrichtEingabe: '',
				nachrichten: [
					{sender: 'AVENUEbot', message: 'Herzlich willkommen'}
				],
			}
		},
		methods: {
			async nachrichtSenden() {
				if (this.nachrichtEingabe != '') {
					/* Nachricht des Teilnehmenden in die Nachrichtenhistorie übernehmen */
					var nachrichtTeilnehmer = {
						id: 'nachricht' + this.nachrichten.length,
						sender: this.teilnehmer,
						message: this.nachrichtEingabe
					}
					this.nachrichten.push(nachrichtTeilnehmer);
					this.nachrichtEingabe = '';
					/* Nachricht an den Chatbot senden */
					try {
						const json = JSON.stringify(nachrichtTeilnehmer);
						const response = await axios.post('https://wsmi-95.wiso.uni-erlangen.de/rasa/webhooks/rest/webhook', json, {
							headers: {
								'Content-Type': 'application/json'
							}
						});
						const data = await response;
						if (data) {
							for (let i = 0; i < data.data.length; i++) {
								var antwortRasa = data.data[i];
								// var currentdate = new Date();
								var antwortAvenue = {
									id: 'nachricht' + this.nachrichten.length,
									sender: 'AVENUEbot',
									message: antwortRasa.text
								};
								this.nachrichten.push(antwortAvenue);
							}
						}
					} catch (error) {
						console.log(error);
					}
				}
			},
		},
		updated() {
			if (this.$refs.nachrichten.children.length > 1) {
				const letzteNachricht = this.$refs.nachrichten.lastElementChild;
				var letzteNachrichtId = document.getElementById(letzteNachricht.id);
				letzteNachrichtId.scrollIntoView();
			}
		},
		computed: {
			teilnehmer() {
				return this.$store.state.teilnehmer;
			}
		},
	}
</script>
<style scoped>
	#konversation {
		position: absolute;
		bottom: 0;
		width: 100%;
		padding: 1em;
	}
	#nachrichten {
		overflow-y: auto;
		scroll-behavior: smooth;
		transition: 0.2s;
	}
	.nachricht {
		min-height: 5em;
		margin-bottom: 1em;
	}
	.sprechblase {
		border: solid #000000 1px;
		margin-left: 10%;
		margin-right: 5em;
		padding: 0.5em;
		font-size: 0.85em;
		background-color: #fbffdc;
		border-top-left-radius: 15px;
		border-top-right-radius: 15px;
		border-bottom-right-radius: 0px;
		border-bottom-left-radius: 15px;
	}
	.sprechblasebot {
		margin-left: 5em;
		margin-right: 10%;
		background-color: #d8fcdd;
		border-color: #055d05;
		border-top-left-radius: 15px;
		border-top-right-radius: 15px;
		border-bottom-right-radius: 15px;
		border-bottom-left-radius: 0px;
	}
	.atavar {
		float: right;
		position: relative;
		top: 1em;
	}
	.atavarbot {
		float: left;
	}
</style>
